import { IServerResponse } from '../../../global/interfaces/server_response';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';
import { ILoginAttemptsDatasource } from '../../datasources/login_attempts_datasource';
import { ICommand } from 'core-ts-types';
import { AccountDatasource } from '../../datasources/account_datasource';

export interface ILoginForm {
  username: string;
  password: string;
}

export class LoginController {
  public loginForm: ILoginForm;
  public validations: {
    email: RegExp;
  };
  private MAX_LOGIN_ATTEMPTS = 5;
  private showLoginAttemptFailureMessage = false;
  private blockLoginAttempts = false;
  private errors: ErrorsDict;
  constructor(
    public $state: angular.ui.IStateService,
    private $stateParams: angular.ui.IStateParamsService,
    private ngLoginAttemptsDatasource: ILoginAttemptsDatasource,
    private loginCommand: ICommand,
    private resetLocalAccountCommand: ICommand,
    private requestAnonymousAccountCommand: ICommand,
    private emailRegex: RegExp,
    private ngAccountDatasource: AccountDatasource,
    private phxNotificationDelegate: any,
    private formErrorService: IFormErrorService
  ) {
    this._initialize($stateParams.user_name);
    this.validations = {
      email: this.emailRegex
    };
  }

  private _initialize(username?: string): void {
    this.loginForm = {
      username: username || '',
      password: ''
    };
  }

  submitForm(): void {
    const loginAttempt = this.ngLoginAttemptsDatasource.get(this.loginForm.username);
    if (loginAttempt && loginAttempt.attempts! >= this.MAX_LOGIN_ATTEMPTS) {
      this.blockLoginAttempts = true;
      return;
    }
    this.errors = {};
    this.loginCommand(this.loginForm)
      .then(() => {
        const {
          is_transfer_counselor,
          is_transfer_admin,
          is_transfer_analytics_user
        } = this.ngAccountDatasource.read();
        const is_admin_user = is_transfer_admin || is_transfer_counselor || is_transfer_analytics_user;
        const destPage = is_admin_user ? 'admin' : 'my.transfer.credits';
        this.$state.transitionTo(destPage, {}, { reload: true });
      })
      .catch((res: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.errors = this.formErrorService(res.data!.error);
        this.showLoginAttemptFailureMessage = true;
        // https://jira.devops.eab.com/browse/UI-1493
        const errorNoticeElement = angular.element('#form-login-server-error')[0];
        if (errorNoticeElement) {
          errorNoticeElement.setAttribute('tabindex', '-1');
          errorNoticeElement.focus();
        }
        this.ngLoginAttemptsDatasource.put({ id: this.loginForm.username });
      })
      .finally(() => {
        this.phxNotificationDelegate.dismissAllNotifications();
      });
  }
}

angular.module('capability-ng-user-app').controller('ngLoginController', LoginController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/login/login.ts